import httpService from "./http.service";

class CustomersService {
  getCustomersUrl = "/users/";
  //   customersAC = "/customer/ac";

  getCustomers = () => {
    return httpService.get(this.getCustomersUrl);
  };
  searchCustomers = (search, params = {}) => {
    return httpService.get(this.getCustomersUrl, {
      params: {
        page: 1,
        pageSize: 10,
        search,
        ...params,
      },
    });
  };
  getCustomer = (id) => {
    return httpService.get(this.getCustomersUrl + id);
  };
  createCustomer = (model) => {
    return httpService.post("/users", model);
  };
  getCustomerPrescriptions = (id) => {
    return httpService.get(`/users/${id}/prescriptions`);
  };
  uploadCustomerPrescription = (id, model) => {
    return httpService.form(`/users/${id}/prescriptions`, model, "uploadCustomerPrescription");
  };
  updateCustomerPrescription = (id, prescriptionId, model) => {
    return httpService.form(
      `/users/${id}/prescriptions/${prescriptionId}`,
      model,
      "updateCustomerPrescription",
      {},
      "patch"
    );
  };
  editCustomer = (id, model) => {
    return httpService.patch("/users/" + id, model);
  };
  deleteCustomer = (id) => {
    return httpService.delete("/customers/" + id);
  };
}

const customersService = new CustomersService();
export default customersService;
